<script setup>
import { useGlobalStore } from "@stores/global.js";

const props = defineProps(["title"]);

const global = useGlobalStore();
</script>

<template>
	<section class="pt-48 lg:pt-160 lg:pb-80">
		<div class="container">
			<div class="relative">
				<h1 class="lg:h2 h4 font-primary">{{ title }}</h1>
				<div
					class="font-primary absolute -bottom-16 -left-90 hidden text-[200px] leading-[0.7] text-transparent uppercase opacity-10 lg:block"
					style="
						-webkit-text-stroke-width: 1px;
						-webkit-text-stroke-color: black;
					"
					aria-hidden="true"
				>
					{{ title }}
				</div>
			</div>
		</div>
	</section>
</template>
